import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import "./ChartBar.css";
import { styled } from "@material-ui/core";

interface Plan {
  details: string;
  energyCharge: string;
  baseCharge: string;
}

const ChartBar = ({ plan1, plan2 }) => {
  const [chartData, setChartData] = useState<any[]>([]);
  const [compNameKey, setCompNameKey] = useState("");
  const [usage, setUsage] = useState(500); // Added state for usage

  useEffect(() => {
    calculateCosts();
  }, []);

  const calculateCosts = () => {
    if (!plan1 || !plan2) return;
    let planACost = 0;
    let planBCost = 0;

    const plans = [plan1, plan2];

    plans.forEach((plan: any) => {
      const energyCost = parseFloat(plan.rates["500kWh"]) * (usage / 100);
      const baseCharge =
        plan.baseCharge === "None" ? 0 : parseFloat(plan.baseCharge);
      const totalCost = energyCost + baseCharge;

      if (plan.details === "Plan A") {
        planACost = totalCost + 20;
      } else if (plan.details === "Plan B") {
        planBCost = totalCost + 150;
      }
    });

    const CompName = plan2.name;
    setCompNameKey(CompName); // Update the state with the dynamic key
    setChartData([{ name: "Cost", BKV: planACost, [CompName]: planBCost }]);
  };

  console.log(chartData);

  const formatTickItem = (tickItem: any) => `$${tickItem}`;

  const CustomH1 = styled("h1")({
    color: "#09507F",
    fontFamily: "Larken DEMO medium",
    fontSize: "36px",
    fontWeight: 400,
    lineHeight: "47.7px",
    textAlign: "left",
    marginTop: "28px",
    marginBottom: "28px",
    "@media (max-width: 768px)": {
      fontSize: "25px",
      lineHeight: "35px",
      fontWeight: 600,
    },
  });

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div
          className="custom-tooltip"
          style={{
            backgroundColor: "#fff",
            padding: "10px",
            border: "1px solid #ccc",
          }}
        >
          <p className="label">{`COST`}</p>
          <p className="intro">{`BKV: $${payload[0].value}`}</p>
          <p className="intro">{`${compNameKey}: $${payload[1].value}`}</p>
        </div>
      );
    }

    return null;
  };

  return (
    <div>
      <CustomH1>Compare an estimated bill with specific usage.</CustomH1>
      <div className="flex-row">
        <input
          type="number"
          value={usage}
          onChange={(e) => setUsage(Number(e.target.value))}
          className="input"
          placeholder="Usage in kWh"
        />
        <button onClick={calculateCosts} className="button">
          Calculate
        </button>
      </div>
      <ResponsiveContainer height={300}>
        <BarChart data={chartData} barGap={100}>
          <CartesianGrid strokeDasharray="3 3" />
          {/* <XAxis dataKey="name" /> */}
          <YAxis tickFormatter={formatTickItem} />
          <Tooltip
            content={
              <CustomTooltip
                active={undefined}
                payload={undefined}
                label={undefined}
              />
            }
          />
          <Legend verticalAlign="top" align="center" />
          <Bar
            dataKey="BKV"
            fill="#00B49D"
            barSize={95}
            radius={[15, 10, 0, 0]}
            fontFamily="Futura PT Book"
          />
          <Bar
            dataKey={compNameKey}
            fill="#D5EEEA"
            barSize={95}
            radius={[15, 10, 0, 0]}
            fontFamily="Futura PT Book"
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ChartBar;
